import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.KEYCLOAK_URL as string,
  realm: process.env.KEYCLOAK_REALM as string,
  clientId: process.env.KEYCLOAK_CLIENT_ID as string,
});

export default keycloak;
